function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function TabsWithPills(props) {
  const { tabs, onTabChange, className } = props;

  return (
    <div className={className}>
      <div className="sm:block">
        <nav
          aria-label="Tabs"
          className="flex space-x-2"
        >
          {tabs.map((tab, index) => (
            <a
              key={tab.name}
              href={tab.href}
              onClick={(e) => {
                e.preventDefault();
                onTabChange(e, { tab, index });
              }}
              aria-current={tab.current ? "page" : undefined}
              className={classNames(
                tab.current
                  ? "rounded-lg bg-gray-100 text-gray-900 dark:bg-white/10 dark:text-white font-semibold"
                  : "text-gray-500 hover:outline hover:outline-gray-100 hover:bg-gray-50 hover:text-gray-800 dark:text-gray-400 dark:hover:text-white",
                "flex items-center whitespace-nowrap rounded-md px-3 py-2 text-sm"
              )}
            >
              {tab.icon ? <span className="mr-2">{tab.icon}</span> : null}
              {tab.name}
              {tab.count ? (
                <span
                  className={classNames(
                    tab.current
                      ? "bg-indigo-100 text-indigo-600"
                      : "bg-gray-100 text-gray-900",
                    "ml-3 rounded-full px-2.5 py-0.5 text-xs font-medium md:inline-block"
                  )}
                >
                  {tab.count}
                </span>
              ) : null}
            </a>
          ))}
        </nav>
      </div>
    </div>
  );
}
